export default "__VITE_ASSET__CfU097Ui__"